/** Batch Creation — the form: a Condition lot's next batch, into one or two SLOCs. */
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { BatchNewPage } from "@/features/warehouse/components/batch-new-page";
import { asStage, useDeskFacility } from "@/features/warehouse/route-helpers";
import { guardDesk } from "../../-guard";

/** `lotId`: open on that lot (the list's "New batch from this lot", the "Another batch" toast). */
const search = z.object({
  lotId: z.coerce.number().int().positive().optional().catch(undefined),
});

export const Route = createFileRoute("/_app/warehouse/$stage/batch/new")({
  validateSearch: search,
  beforeLoad: ({ params }) =>
    guardDesk(params.stage, "warehouse.batch", "batch"),
  component: Page,
});

function Page() {
  const { stage } = Route.useParams();
  const { lotId } = Route.useSearch();
  return (
    <BatchNewPage
      key={lotId ?? ""}
      stage={asStage(stage)}
      facilityId={useDeskFacility()}
      lotId={lotId}
    />
  );
}
